
export type DeleteTweet200 = {
  code?: string;
  message?: string;
  success?: boolean;
};
